export default __webpack_public_path__ + "static/media/logout.88c617d2.svg";